import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/node_modules/next/dist/client/image-component.js");
